module.exports = __webpack_public_path__ + "img/Payments.f0797610.svg";